import {
  DialogActions as NatDsDialogActions,
} from '@naturacosmeticos/natds-web'

export const DialogActions = NatDsDialogActions
